import { createSelector } from 'reselect';

import { initialState, OrganizationPageState } from './reducer';
import { key } from './constants';

const selectState = (state: any): OrganizationPageState => state.get(key) || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
export const selectError = createSelector(selectState, (state) => state.get('error'));
export const selectNewAddress = createSelector(selectState, (state) => state.get('newAddress'));
